import axios from "axios";
import { push } from "connected-react-router";

import { ServerAddress , DomesticHotelApiUrls , Header } from "../Enum/Urls";
import { editMessage,showError } from "./VisualDataAction";
import LayoutConfig from "../Config/layoutConfig";

export const setDomesticHotelFilter = (filterType, value) => ({
    type: "SetDomesticHotelFilter",
    filterType,
    value
});

export const setReservedHotel = (data) => ({
    type: "SetReservedDomesticHotel",
    data
});

export const setHotelByIdInfo = (data) => ({
    type: "SetDomesticHotelByIdInfo",
    data
});

export const DomesticHotelPreReserve = async (param, token = null , currentLang = 'fa') => {
    try {
      
      let HeaderAuth={
        ...Header,
        apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
        'Accept-Language': `${currentLang === 'fa' ? 'fa-IR' : 'ar-AE'}`
      };

      if(token){
        HeaderAuth={
            ...Header,
            apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
            'Accept-Language': `${currentLang === 'fa' ? 'fa-IR' : 'ar-AE'}`,
            Authorization:`Bearer ${token}`
          };
      }

      let response = await axios.post(`${ServerAddress.Type}${ServerAddress.DomesticHotelB}${DomesticHotelApiUrls.PreReserveHotel}`,
        param,
        {
          headers: HeaderAuth
        },
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getReserveByIdDomesticHotel = (params, token,  currentLang = 'fa', withHotelByIdRequest = false) => {
  
  if (LayoutConfig.loginToContinueReserve && !token) return;

  let HeaderAuth;
  if (token) {
    HeaderAuth = { 
      ...Header,
      Authorization: `Bearer ${token}`, 
      apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
      'Accept-Language': `${currentLang === 'fa' ? 'fa-IR' : 'ar-AE'}`,
    };
  } else {
    HeaderAuth = { 
      ...Header,
      apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
      'Accept-Language': `${currentLang === 'fa' ? 'fa-IR' : 'ar-AE'}`,
    };
  }


  return (dispatch) => {
    axios({
      method: "get",
      params,
      url: `${ServerAddress.Type}${ServerAddress.DomesticHotelB}${DomesticHotelApiUrls.GetReserveById}`,
      headers: HeaderAuth
    })
      .then((response) => {
        dispatch(setReservedHotel(response.data.result));
        const hotelId = response.data.result?.accommodation?.id;
        if (withHotelByIdRequest && hotelId) {

          getDomesticHotelSummaryDetailById(hotelId).then((response) => {
            if(response?.data?.result){
              dispatch(setHotelByIdInfo(response.data.result));
              dispatch(editMessage(true));
            }
          })
        } else {
          dispatch(editMessage(true));
        }
      })
      .catch((error) => {
        try {
          dispatch(showError({ visibility: true, content: error.response.data.error.message }))
        } catch (e) {
          dispatch(showError({ visibility: true, content: "Internal Error,Please refresh the page" }))
        }
      });
  }
};

export const confirmDomesticHotel = (params,token) => {

  let HeaderAuth;
  
  if (token) {
    HeaderAuth = { 
      ...Header,
      Authorization: `Bearer ${token}`, 
      apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
      'Accept-Language': 'fa-IR'
    };
  } else {
    HeaderAuth = { 
      ...Header,
      apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
      'Accept-Language': 'fa-IR'
    };
  }

  return (dispatch) => {
    axios({
      method: "post",
      url: `${ServerAddress.Type}${ServerAddress.DomesticHotelB}${DomesticHotelApiUrls.Confirm}`,
      data: { ...params },
      headers: HeaderAuth
    })
      .then((response) => {
        dispatch(
          push(
            `/profile/details?userName=${params.username}&reserveId=${params.reserveId}`
          )
        );
      })
      .catch((error) => {
        try {
          dispatch(
            push(
              `/profile/details?userName=${params.username}&reserveId=${params.reserveId}`
            )
          );
        } catch (e) {
          dispatch(
            showError({
              visibility: true,
              content: "Internal Error,Please refresh the page",
            })
          );
        }
      });
  };
};

export const SearchAccomodation = async (parameters, acceptLanguage = 'fa-IR') => {
    try {
        
        const paramsArray = [];
        if(parameters.EntityId){
            paramsArray.push(`EntityId=${parameters.EntityId}`);
        }

        if(parameters.url){
            paramsArray.push(`Url=${parameters.url}`);
        }

        const requestUrl = ServerAddress.Type + ServerAddress.DomesticHotelC + DomesticHotelApiUrls.SearchAccomodations+ "?" + paramsArray.join("&") ;

        let response = await axios.get(
            requestUrl,
            {
                headers: {
                    'Content-Type': 'application/json',
                    apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
                    'Accept-Language': acceptLanguage,
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}


export const getDomesticHotelDetailsById = async (id, acceptLanguage = 'fa-IR') => {
    try {
        let response = await axios.get(
            `${ServerAddress.Type}${ServerAddress.DomesticHotelPerformance}${DomesticHotelApiUrls.GetDomesticHotelDetailById}?id=${id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
                    'Accept-Language': acceptLanguage,
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const createComment = async (param, acceptLanguage = 'fa-IR') => {
    
    try {
        let response = await axios.post(
            `${ServerAddress.Type}${ServerAddress.CMS}${DomesticHotelApiUrls.CreateComment}`,
            param,
            {
                headers: {
                    ...Header,
                    "Accept-Language": acceptLanguage,
                    apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
                    TenantId: process.env.REACT_APP_SERVER_TENANTID
                },
            },
        )
        return response
    } catch (error) {
        return error
    }
}

export const getDomesticHotelSummaryDetailById = async (id) => {
    try {
        const response = await axios({
            method: "get",
            url: `${ServerAddress.Type}${ServerAddress.DomesticHotelC}${DomesticHotelApiUrls.GetHotelSummaryDetailById}?Id=${id}`,
            headers: {
              ...Header,
              "Accept-Language": "fa-IR",
              apikey: "68703d73-c92c-4105-9f71-9f718aaad2cc",
              TenantId: process.env.REACT_APP_SERVER_TENANTID
            }
        });
        return (response)
    } catch (error) {
        return error
    }
}
